<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template>
      <!-- 复合搜索框 -->
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`待审核运单`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template #orderNum="params">
        <div class="orderNum" :class="params.params.is_reject == 1 ? 'tui' : ''">
          {{ params.params.order_num }}
        </div>
      </template>
      <template slot="status" slot-scope="params">
        <span class="status status0" v-if="params.params.isfleet == 1">队长未审</span>
        <span class="status status1" v-if="params.params.isfleet == 2">队长已审</span>
      </template>
      <template #btns="params">
        <Btn v-if="![2, 3, 4].includes(user.user_group_id)" :config="btns[0]" :data="params.params" />
        <Btn v-if="showEditBtn(params.params)" :config="btns[1]" :data="params.params" />
        <Btn v-if="!showEditBtn(params.params)" :config="viewBtn" :data="params.params" />
        <Btn :config="btns[2]" :data="params.params" />
        <Btn :config="btns[3]" :data="params.params" />
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'order',
      formInline: {
        ischeck: 1,
        isstatus: 5,
      },
      formCtrl: [],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 150, slot: 'orderNum' },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 120 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "isfleet", label: "审核状态", slot: 'status', minwidth: 120 },
        { keyName: "", label: "操作", fixed: 'right', slot: 'btns', minwidth: 170 },
      ],
      btns: [
        {
          class: 'dispatchbtn',
          title: '再派一单',
          img: require('@/assets/img/icon-paidan.png'),
          unimg: require('@/assets/img/icon-paidan-hover.png'),
          cb: ({ id }) => {
            this.$router.push(`/order/nocontractadd?id=${id}`)
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            // console.log(id)
            this.$router.push(
              `/order/nocontractview5?id=${id}&mode=edit`
            );
          },
        },
        {
          ...this.feeBtn,
          cb: ({ id, isfleet }) => {
            // console.log('id', id)
            const { user_group_id } = this.user
            let mode = 'edit'
            if (
              user_group_id == 5 && isfleet == 2 ||
              ([2, 3, 4].includes(user_group_id) && isfleet == 1)
            ) {
              mode = 'view'
            }
            this.$router.push(
              `/order/nocontractfee?id=${id}&mode=${mode}`
            );
          },
        },
      ],
      viewBtn: {
        ...this.viewBtn,
        cb: ({ id }) => {
          // console.log(id)
          this.$router.push(
            `/order/nocontractview4?id=${id}&mode=view`
          );
        },
      },
    };
  },
  methods: {
    showEditBtn(a) {
      let boo = false
      const { user_group_id } = this.user
      const { isstatus, isover, is_reject, isfleet } = a
      if (
        // 司机
        user_group_id == 9 && (isstatus == 3 && isover == 1 || (is_reject == 1 && isover == 1) || isstatus == 2) ||
        // 队长
        (user_group_id == 5 && (isstatus == 3 && isover == 2 && isfleet == 1 || (isstatus == 3 && isover == 1) || [1, 2].includes(isstatus))) ||
        // 财务
        ([2, 3, 4].includes(user_group_id) && isstatus == 3 && isover == 2 && isfleet == 2) ||
        // 超管
        user_group_id == 1
      ) {
        boo = true
      }
      return boo
    },
  },
  mounted() {
    const { user_group_id } = this.user
    if (user_group_id == 1) {
      this.btns.push({
        ...this.delBtn,
        cb: this.delete,
      })
    }
    // if ([5].includes(user_group_id)) {
    //   this.btns[1] = {
    //     ...this.viewBtn,
    //     cb: ({ id }) => {
    //       this.$router.push(
    //         `/order/nocontractview3?id=${id}&mode=view`
    //       );
    //     },
    //   }
    // }
    if ([2, 3, 4].includes(user_group_id)) {
      // 财务没有再派一单，按钮列宽度变窄
      this.cols[this.cols.length - 1].minwidth = '112px'
    }
  },
};
</script>

<style lang="less" scoped>
.main {
  .table-wrap {
    /deep/ .el-table {
      .orderNum {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .tui {
        position: relative;

        &::after {
          content: '';
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url(../../../../../assets/img/icon_reject.png) no-repeat center center;
          background-size: 20px;
        }
      }

      .status {
        &.status1 {
          color: #45A814;
        }

        &.status0 {
          color: #E61E1E;
        }
      }
    }
  }
}
</style>
